module.exports = __webpack_public_path__ + "img/survey.a426af9.svg";